<script lang="ts">
import { defineComponent, Ref, ref } from 'vue';
import NavigationInnerHead from 'components/User/NavigationInnerHead.vue';
import UserService from 'src/core/services/UserService';
import { useQuasar } from 'quasar';
import { UserPasswordInfo } from 'src/core/types/User';

export default defineComponent({
  name: 'Password',

  components: { NavigationInnerHead },

  setup() {
    const $q = useQuasar();
    const formData: Ref<UserPasswordInfo> = ref({
      oldPassword: '',
      password: '',
      passwordAgain: '',
    });

    const updateLoading = ref(false);

    return {
      formData,
      updateLoading,
      updatePassword() {
        updateLoading.value = true;
        UserService.updatePassword({ ...formData.value })
          .then(({ status, message }) => {
            if (status._200_) {
              $q.notify({
                color: 'green',
                icon: 'fa-regular fa-circle-check',
                message: 'Şifre bilginiz güncellenmiştir',
              });
              Object.keys(formData.value).forEach((key: string) => {
                const typedKey = key as keyof UserPasswordInfo;
                formData.value[typedKey] = '';
              });
            } else {
              $q.notify({
                color: 'red',
                icon: 'fa-solid fa-circle-exclamation',
                message,
              });
            }
            updateLoading.value = false;
          })
          .catch(() => {
            updateLoading.value = false;
          });
      },
    };
  },

  methods: {
    sifreGuncelle() {
      // UserServices.sifreGuncelle(this.sifreData).then((res) => {
      //   /* ... */
      // });
    },
  },
});
</script>

<template>
  <q-card class="bg-transparent shadow-0">
    <div class="flex justify-between items-center q-mb-md">
      <div>
        <navigation-inner-head title="Şifre Güncelleme" icon="https" />
      </div>
      <div></div>
    </div>
    <q-separator color="accent" />
    <div class="row">
      <div class="col-12 row q-py-lg">
        <div class="col-12 col-lg-6">
          <q-input v-model="formData.oldPassword" type="password" filled label="Eski Şifre" hint="Lütfen güncellemek için önce eski şifrenizi girin" />
        </div>
      </div>
      <div class="row col-xs-12 q-py-md">
        <div class="col-12 col-lg-6">
          <q-input v-model="formData.password" type="password" filled label="Yeni Şifre" hint="Lütfen yeni bir şifre belirleyin" />
        </div>
      </div>
      <div class="row col-xs-12 q-py-md">
        <div class="col-12 col-lg-6">
          <q-input v-model="formData.passwordAgain" type="password" filled label="Yeni Şifre Tekrar" hint="Lütfen yeni şifrenizi tekrar girin" />
        </div>
      </div>
      <div class="col-12 col-lg-6 q-my-md flex justify-end">
        <q-btn label="Şifremi Güncelle" color="green" @click="updatePassword" :loading="updateLoading" no-caps class="text-subtitle1" />
      </div>
    </div>
  </q-card>
</template>

<style scoped></style>
